import type { SEmbedConfig } from "@norma-bi/bi-api";

export function sEmbedAppPath(config: SEmbedConfig) {
  return `/embed/workspaces/${encodeURIComponent(config.workspaceKey)}/apps/${encodeURIComponent(config.appKey)}`;
}

export function sNavigationHostPath(path: string, config: SEmbedConfig): string | null {
  const origin = new URL(config.webUiUrl).origin;
  const url = new URL(path, origin);
  const base = sEmbedAppPath(config);
  if (url.origin !== origin || (url.pathname !== base && !url.pathname.startsWith(`${base}/`))) {
    return null;
  }
  return `/home${url.pathname.slice(base.length)}${url.search}${url.hash}`;
}

export function sHostSettingsPath(url: string, hostOrigin: string): string | null {
  const target = new URL(url, hostOrigin);
  if (
    target.origin !== hostOrigin ||
    (target.pathname !== "/settings" && !target.pathname.startsWith("/settings/"))
  ) {
    return null;
  }
  return `${target.pathname}${target.search}${target.hash}`;
}
